import Button from "react-bootstrap/Button";
import Table from "react-bootstrap/Table";
import Card from "react-bootstrap/Card";
import Pagination from "react-bootstrap/Pagination";
import { useState, useEffect } from "react"
import InputMask from 'react-input-mask';
import { useToasts } from 'react-toast-notifications';
import moment from 'moment'
import currency from "currency.js";
import Avatar from "../../common/Avatar";
import { Link } from "react-router-dom";
import useDidMountEffect from '../../utils/useDidMountEffect'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './style.scss';

import "../../styles.css";
import { Spinner } from "react-bootstrap";

const PuEarningList = () => {
    const numDates = 12;

    const { addToast } = useToasts();

    const [date, setDate] = useState('')
    const [login, setLogin] = useState('')
    const [busy, setBusy] = useState(false)
    const [page, setPage] = useState(1)
    const [earnings, setEarnings] = useState([])
    const [columns, setColumns] = useState([])
    const [total, setTotal] = useState(0)
    const [pageItems, setPageItems] = useState([])
    const [summary, setSummary] = useState([])
    const [orderBy, setOrderBy] = useState('ASC')
    const [isSearching, setIsSearching] = useState(false)
    const [itemCount, setItemCount] = useState(0)
    const [perPage, setPerPage] = useState(0)
    const [isGettingEarnings, setIsGettingEarnings] = useState(false)
    
    const getPerPage = async() => {
        await axios.get(`/api/settings`, {
                params: {
                    only: 'max_users_per_page'
                }
            })
            .then(response => {
                const data = Object.assign({}, ...response.data);
                setPerPage(parseInt(data.max_users_per_page) ?? 15)
            })
    }

    useEffect(() => {
        getPerPage()
        generateColumns()
        getSummary()
    }, [])

    useDidMountEffect(() => {
        getPuEarnings()
    }, [perPage])

    useDidMountEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            getPuEarnings();
        }, 800);
        return () => clearTimeout(delayDebounceFn);
    }, [page])

    const handleSubmit = (e) => {
        e.preventDefault()
        setPage(1)
        getPuEarnings()
        getSummary()
        generateColumns(date)
    }

    const getPuEarnings = () => {
        setIsGettingEarnings(true)
        axios.get('/api/administration/pu-earnings', {
            params: {
                page: page,
                per_page: perPage,
                login: login,
                date: date,
                order_by: orderBy
            }
        })
            .then(response => {
                setEarnings(response.data.data)
                setItemCount(response.data.total)
                setTotal(Math.ceil(response.data.total / perPage))
                setIsGettingEarnings(false)
            })
            .catch(error => {
                addToast('Unable to get pu earnings', { appearance: 'error', autoDismiss: true });
                setIsGettingEarnings(false)
            })
    }

    const getSummary = () => {
        setBusy(true)
        axios.get('/api/administration/pu-earnings/summary', {
            params: {
                date: date
            }
        })
            .then(response => {
                setSummary(response.data)
                console.log({ summary })
            })
            .catch(error => {
                addToast('Unable to get earning summary', { appearance: 'error', autoDismiss: true });
            })
            .finally(() => {
                setBusy(false)
            })
    }

    useDidMountEffect(() => {
        getSummary();
        generatePages();
    }, [page])

    useDidMountEffect(() => {
        getPuEarnings()
    }, [orderBy])

    useDidMountEffect(() => {
        generatePages()
    }, [total])

    useDidMountEffect(() => {
        if (isSearching && date) {
            generateColumns(date)
        }
    }, [isSearching])

    const generatePages = () => {
        let tmpPagination = []
        for (let i = 0; i < total; i++) {
            const actualPage = i + 1
            tmpPagination.push(
                actualPage
            )
        }
        setPageItems(tmpPagination)
    }

    const generateColumns = (dateParam = null) => {
        let tmpCol = ['Username']
        let dateFormatted = null

        if (dateParam) {
            const tmp = dateParam.split('/')
            dateFormatted = `${tmp[1]}-${tmp[0]}-01`
        }

        for (let i = 0; i < numDates; i++) {
            const now = dateFormatted ? moment(dateFormatted) : moment()
            tmpCol.push(now.subtract(i, 'months').format('MMM YYYY'))
        }

        setColumns(tmpCol)
    }

    const PaginationContainer = () => {
        const isDisabled = page > 1 ? false : true;
        return (
            <Pagination style={{ justifyContent: "flex-end", alignItems: 'center' }}>
                <span className="mr-3">
                    {itemCount} item{total > 1 ? 's' : ''}
                </span>
                {/* <Pagination.First disabled={isDisabled} className="mr-1" /> */}
                <Pagination.Prev disabled={isDisabled} onClick={page => setPage(page => page-1)}  />
                <div className="mx-2 d-flex flex-row align-items-center justify-content-center w-auto">
                    <div className="mr-1" style={{ width: 35 }}>
                        <input
                            type="text"
                            className="pagination-input"
                            onChange={(e) => setPage(e.target.value)}
                            value={page}
                        />
                    </div>
                    of {total}
                </div>
                <Pagination.Next disabled={page==total} onClick={page => setPage(page => page+1)} />
                {/* <Pagination.Last className="ml-1" /> */}
            </Pagination>
        )
    }

    const clearUsernameSearchText = () => {
        setLogin('');
    }

    return (
        <div className="admin__pu-earning-list">
            <h3 className="mb-4">PU Earning Records</h3>
            <div className="my-4">
                <form onSubmit={handleSubmit}>
                    <div className="form-row align-items-center">
                        <div className="my-1 input-container date">
                            <label htmlFor="date" className="mr-1 font-bold">
                                12 months back from :{" "}
                            </label>
                            <InputMask
                                mask="99/9999"
                                className="form-control-sm col-6 input-sm"
                                id="date"
                                name="date"
                                placeholder="mm/yyyy"
                                disabled={busy}
                                onChange={(e) => setDate(e.target.value)}
                                value={`${date}`}
                            />
                        </div>

                        <div className="my-1 input-container">
                            <input
                                type="text"
                                className={`form-control ${login ? 'mr-0' : 'mr-16p'}`}
                                id="login"
                                placeholder="PU username"
                                disabled={busy}
                                onChange={(e) => setLogin(e.target.value)}
                                value={`${login}`}
                            />
                            {
                                login && <i className="fal fa-times search-clear-icon" onClick={clearUsernameSearchText} />
                            }
                        </div>

                        <div className="mx-2 my-1">
                            <Button
                                variant="primary"
                                disabled={busy}
                                onClick={handleSubmit}
                            >
                                {busy ? "Searching..." : "Search"}
                            </Button>
                        </div>
                    </div>
                </form>
            </div>

            <div className="content">
                <div className="summary mb-4">
                    <Card className="shadow-sm" style={{ padding: '0 1.25rem' }}>
                        <Table size="sm" responsive className="mb-0">
                            <thead>
                                <tr>
                                    {columns.map((column, index) => {
                                        return (
                                            <th
                                                width={index==0 ? '15%' : '7%'}
                                                key={`summary-${column}-${index}`}
                                                className="border-top-0"
                                                style={{ textAlign: column == "Username" ? 'left' : 'right' }} >
                                                {column == "Username"
                                                    ? " "
                                                    : moment(column).format(
                                                        "MMM YYYY"
                                                    )}
                                            </th>
                                        );
                                    })}
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <strong>PU Total</strong>
                                    </td>
                                    {summary.pu_total &&
                                        Object.keys(summary.pu_total).map(
                                            (key, index) => {
                                                return (
                                                    <td
                                                        style={{ textAlign: 'right' }}
                                                        key={`pu-total-${index}`}>
                                                        {currency(
                                                            summary.pu_total[key]
                                                        ).format()}
                                                    </td>
                                                );
                                            }
                                        )}
                                </tr>
                                <tr>
                                    <td>
                                        <strong>Admin Total</strong>
                                    </td>
                                    {summary.admin_total &&
                                        Object.keys(summary.admin_total).map(
                                            (key, index) => {
                                                return (
                                                    <td
                                                        style={{ textAlign: 'right' }}
                                                        key={`admin-total-${index}`}>
                                                        {currency(
                                                            summary.admin_total[
                                                            key
                                                            ]
                                                        ).format()}
                                                    </td>
                                                );
                                            }
                                        )}
                                </tr>
                                <tr>
                                    <td>
                                        <strong>Grand Total</strong>
                                    </td>
                                    {summary.grand_total &&
                                        Object.keys(summary.grand_total).map(
                                            (key, index) => {
                                                return (
                                                    <td
                                                        style={{ textAlign: 'right' }}
                                                        key={`grand-total-${index}`}>
                                                        {currency(
                                                            summary.grand_total[
                                                            key
                                                            ]
                                                        ).format()}
                                                    </td>
                                                );
                                            }
                                        )}
                                </tr>
                            </tbody>
                        </Table>
                    </Card>
                </div>
                <div className="text-right my-2">
                    {PaginationContainer()}
                </div>
                <div className="pu-table-container">
                    <Card className="border-0" style={{ padding: '0' }}>
                        {
                            isGettingEarnings && <div>
                                <Spinner animation="border" size="sm" variant="primary" />
                            </div>
                        }
                        <Table size="sm" striped hover responsive className="mb-0">
                            <thead>
                                <tr>
                                    {columns.map((column, index) => (
                                        <th
                                            width={index==0 ? '15%' : '7%'}
                                            className="border-top-0"
                                            key={column}
                                            style={{ textAlign: column == "Username" ? 'left' : 'right' }}>
                                            {column != "Username"
                                                ? moment(column).format("MMM YYYY")
                                                : column}{" "}
                                            {column == "Username" &&
                                                orderBy == "ASC" ? (
                                                <a
                                                    href="#"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        setOrderBy("DESC");
                                                    }}
                                                    style={{ fontSize: "10px" }}
                                                >
                                                    <FontAwesomeIcon
                                                        icon={["fas", "chevron-down"]}
                                                    />
                                                </a>
                                            ) : (
                                                ""
                                            )}
                                            {column == "Username" &&
                                                orderBy == "DESC" ? (
                                                <a
                                                    href="#"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        setOrderBy("ASC");
                                                    }}
                                                    style={{ fontSize: "10px" }}
                                                >
                                                    <FontAwesomeIcon
                                                        icon={["fas", "chevron-up"]}
                                                    />
                                                </a>
                                            ) : (
                                                ""
                                            )}
                                        </th>
                                    ))}
                                </tr>
                            </thead>

                            <tbody>
                                {earnings.map((earning) => {
                                    return (
                                        <tr key={earning.user.id}>
                                            <td>
                                                <Link to={`/${earning.user.login}`} className="text-left d-flex flex-row align-items-center">
                                                    <div className="mx-1" style={{ width: '12%' }}>
                                                        <Avatar pu={earning.user} />{" "}
                                                    </div>
                                                    {earning.user.login}
                                                </Link>
                                            </td>
                                            <td style={{ textAlign: 'right' }}>
                                                {currency(earning.month_one).format()}
                                            </td>
                                            <td style={{ textAlign: 'right' }}>
                                                {currency(earning.month_two).format()}
                                            </td>
                                            <td style={{ textAlign: 'right' }}>
                                                {currency(
                                                    earning.month_three
                                                ).format()}
                                            </td>
                                            <td style={{ textAlign: 'right' }}>
                                                {currency(
                                                    earning.month_four
                                                ).format()}
                                            </td>
                                            <td style={{ textAlign: 'right' }}>
                                                {currency(
                                                    earning.month_five
                                                ).format()}
                                            </td>
                                            <td style={{ textAlign: 'right' }}>
                                                {currency(earning.month_six).format()}
                                            </td>
                                            <td style={{ textAlign: 'right' }}>
                                                {currency(
                                                    earning.month_seven
                                                ).format()}
                                            </td>
                                            <td style={{ textAlign: 'right' }}>
                                                {currency(
                                                    earning.month_eight
                                                ).format()}
                                            </td>
                                            <td style={{ textAlign: 'right' }}>
                                                {currency(
                                                    earning.month_nine
                                                ).format()}
                                            </td>
                                            <td style={{ textAlign: 'right' }}>
                                                {currency(earning.month_ten).format()}
                                            </td>
                                            <td style={{ textAlign: 'right' }}>
                                                {currency(
                                                    earning.month_eleven
                                                ).format()}
                                            </td>
                                            <td style={{ textAlign: 'right' }}>
                                                {currency(
                                                    earning.month_twelve
                                                ).format()}
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>

                            <tfoot>
                                <tr>
                                    {columns.map((column) => (
                                        <th key={column} style={{ textAlign: column == "Username" ? 'left' : 'right' }}>
                                            {column != "Username"
                                                ? moment(column).format("MMM YYYY")
                                                : column}{" "}
                                            {column == "Username" &&
                                                orderBy == "ASC" ? (
                                                <a
                                                    href="#"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        setOrderBy("DESC");
                                                    }}
                                                    style={{ fontSize: "10px" }}
                                                >
                                                    <FontAwesomeIcon
                                                        icon={["fas", "chevron-down"]}
                                                    />
                                                </a>
                                            ) : (
                                                ""
                                            )}
                                            {column == "Username" &&
                                                orderBy == "DESC" ? (
                                                <a
                                                    href="#"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        setOrderBy("ASC");
                                                    }}
                                                    style={{ fontSize: "10px" }}
                                                >
                                                    <FontAwesomeIcon
                                                        icon={["fas", "chevron-up"]}
                                                    />
                                                </a>
                                            ) : (
                                                ""
                                            )}
                                        </th>
                                    ))}
                                </tr>
                            </tfoot>
                        </Table>
                    </Card>
                </div>
                <div className="text-right my-2">
                    {PaginationContainer()}
                </div>
            </div>
        </div>
    );
}

export default PuEarningList